import { DefaultPageHeader } from 'layouts';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { usePermissions } from 'permissions';
import { CardTabs, Col, Icon, Row } from 'ui';
import { ChangePassword } from './change-password';
import { Passkeys } from './passkeys';
import { RemoveAccount } from './remove-account';
import { SettingsNotifications } from './settings-notifications';
import { type SettingsParams, isSettingsScope } from './types';
import { UserTranslations } from './user-translations';

type P = {
  logOut: () => void;
  tabOptions: SettingsParams;
};

const Settings = ({ logOut, tabOptions }: P) => {
  const { t } = useTranslation();
  const { canViewPasskeys } = usePermissions();

  const items = useMemo(() => {
    const baseItems = [
      {
        children: <SettingsNotifications />,
        icon: <Icon icon="right-line" />,
        key: 'notifications',
        label: t('Notifications'),
      },
      {
        children: <UserTranslations />,
        icon: <Icon icon="right-line" />,
        key: 'language',
        label: t('Languages'),
      },
      {
        children: <ChangePassword />,
        icon: <Icon icon="right-line" />,
        key: 'change-password',
        label: t('Change password'),
      },
    ];

    if (canViewPasskeys({})) {
      baseItems.push({
        children: <Passkeys />,
        icon: <Icon icon="right-line" />,
        key: 'passkeys',
        label: t('Passkeys'),
      });
    }

    baseItems.push({
      children: <RemoveAccount logOut={logOut} />,
      icon: <Icon icon="right-line" />,
      key: 'remove-account',
      label: t('Remove account'),
    });

    return baseItems;
  }, [canViewPasskeys, logOut, t]);

  return (
    <>
      <DefaultPageHeader title="Settings" />
      {/* TODO: there is a problem with tabs height if they are not in the row */}
      <Row>
        <Col>
          <CardTabs
            card={{ marginBottom: false }}
            tabs={{
              activeKey: tabOptions.tab,
              items,
              onChange(activeTabKey) {
                isSettingsScope(activeTabKey) && tabOptions.onChangeTab(activeTabKey);
              },
            }}
          />
        </Col>
      </Row>
    </>
  );
};

export default Settings;
